/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';

import { LeadListBusinessService } from '../../../resources/lead-list-business.service';
import { SalesManagementReportFilterDialogComponent } from './sales-management-report-filter-dialog.component';

export const salesManagementReportFilterDialogRoute = createDialogRoute({
  component: SalesManagementReportFilterDialogComponent,
  init: {
    service: LeadListBusinessService,
    selector: 'initSalesManagementReportFilterDialog',
  },
});
